export const useStickyHeaderBounding = (
  elementId: string = STATIC_HEADER_ID,
) => {
  const stickyHeader = import.meta.server
    ? undefined
    : document.getElementById(elementId);

  const { height: stickyHeaderHeight } = useElementBounding(stickyHeader);

  return { stickyHeaderHeight };
};
